import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted variable fonts (Fontsource).
import '@fontsource-variable/inter';
import '@fontsource-variable/montserrat';
import '@fontsource-variable/cormorant-garamond';

import './styles/index.css';

// Register GSAP + plugins before anything renders (side-effect import), so a
// component effect can never create a ScrollTrigger before registration.
import '@/lib/gsap';

import { App } from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root was not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
